import { useEffect, useState } from "react"
import config from "../app-config"
import { log_user_action } from "../api/analyticsAPI";

export const logout = () => {
    let endpoint = config.endpoint + "/auth/logout"
    fetch(endpoint, {
        credentials: "include",
        method: "POST",
    })
    localStorage.removeItem("user")
    sessionStorage.removeItem("user")
    document.cookie = "token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    window.location.href = "/"
}

export const analyticsCollector = async () => {
    await log_user_action({ device: "web" });
    return;
}

// Request deduplication cache for /auth/authorisation
let pendingAuthRequest = null;

const fetchAuthorisationDataSingleton = async () => {
    if (!pendingAuthRequest) {
        const endpoint = config.endpoint + "/auth/authorisation";
        pendingAuthRequest = fetch(endpoint, {
            credentials: "include",
            method: "POST",
        })
            .then((res) => res.json())
            .catch((err) => ({ status: 500, error: err }))
            .finally(() => {
                setTimeout(() => {
                    pendingAuthRequest = null;
                }, 300);
            });
    }
    return pendingAuthRequest;
};

export const useFetchAuthorisation = (account_type) => {
    const [isAuthorised, setIsAuthorised] = useState(false);
    const [userRole, setUserRole] = useState("");

    useEffect(() => {
        let isMounted = true;
        const fetchAuthorisation = async () => {
            let current_location = encodeURIComponent(window.location.pathname)
            try {
                const data = await fetchAuthorisationDataSingleton();
                if (!isMounted) return;
                if (data.status === 200) {
                    sessionStorage.setItem("user", JSON.stringify(data.data));
                    setUserRole(data?.data?.account_type);
                    if (convertToRole(account_type) <= convertToRole(data?.data?.account_type)) {
                        setIsAuthorised(true);
                    } else {
                        window.location.href = `/auth/login?redirect=${current_location}`
                        setIsAuthorised(false);
                    }
                } else {
                    window.location.href = `/auth/login?redirect=${current_location}`
                    setIsAuthorised(false);
                }
            } catch (error) {
                if (isMounted) setIsAuthorised(false);
            }
        };
        fetchAuthorisation();
        return () => {
            isMounted = false;
        };
    }, [account_type]);

    return { isAuthorised, userRole };
};

export const useFetchUserData = () => {
    const [userData, setUserData] = useState({});

    useEffect(() => {
        let isMounted = true;
        const fetchUserData = async () => {
            try {
                const data = await fetchAuthorisationDataSingleton();
                if (!isMounted) return;
                if (data.status === 200) {
                    sessionStorage.setItem("user", JSON.stringify(data.data));
                    setUserData(data.data);
                } else {
                    setUserData({});
                }
            } catch (error) {
                if (isMounted) setUserData({});
            }
        };
        fetchUserData();
        return () => {
            isMounted = false;
        };
    }, []);

    return userData;
}

export const authorisationConverter = ({ requirement, current_role }) => {
    return convertToRole(requirement) <= convertToRole(current_role)
}

const convertToRole = (role) => {
    switch (role) {
        case "member":
            return 1;
        case "staff":
            return 2;
        case "manager":
            return 3;
        case "admin":
            return 4;
        case "superadmin":
            return 5;
        default:
            return 0;
    }
};